import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { SalesforceChatConfig, ChatSession } from "../types/chat";

export interface SendFileInput {
	session: ChatSession;
	file: File;
	fileName?: string;
	mimeType?: string;
}

interface SendFileResponse {
	fileId: string;
	conversationEntryId: string;
}

export function useSendFile(config: SalesforceChatConfig) {
	return useMutation<SendFileResponse, Error, SendFileInput>({
		mutationFn: async ({ session, file, fileName, mimeType }) => {
			if (!session?.accessToken || !session?.conversationId) {
				throw new Error("Sessão inválida ao enviar arquivo.");
			}

			const url = `${config.scrtUrl}/iamessage/api/v2/conversation/${session.conversationId}/file`;

			const form = new FormData();
			form.append("file", file, fileName || file.name);

			form.append(
				"metadata",
				JSON.stringify({
					esDeveloperName: config.esDeveloperName,
					contentType: mimeType || file.type,
					fileName: fileName || file.name,
				})
			);

			const response = await axios.post(url, form, {
				headers: {
					Authorization: `Bearer ${session.accessToken}`,
					"Content-Type": "multipart/form-data",
				},
			});

			return {
				fileId: response.data.fileId,
				conversationEntryId: response.data.conversationEntryId,
			};
		},
	});
}
